import styled from '@emotion/styled';
import { Flex } from '../../../../Box';
import {
  stylesForDefaultState,
  stylesForFocusState,
  stylesForHoverState,
} from '../../../../_internal/theme/stylesFor';

const ToastsThemeFlexItem = styled(Flex.Item)`
  ${stylesForDefaultState('toasts')}

  &:hover {
    ${stylesForHoverState('toasts')}
  }

  &:focus {
    outline: 0;
    ${stylesForFocusState('toasts')}
  }
`;

export default ToastsThemeFlexItem;
